import React from 'react';

import {
  Webform,
} from '@uncinc/react-drupal-core';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

const WebformBlock = ({ entity, containerless }) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');

  return (
    <div className="WebformBlock">
      <Container>
        <div className="row">
          <div className="WebformBlock__title__wrapper col-12 col-md-8 offset-md-2 offset-lg-1 col-lg-4">
            <h2 className="WebformBlock__title">{title}</h2>
          </div>
          <div className="WebformBlock__webform__wrapper col-12 col-md-8 offset-md-2 col-md-5 col-lg-5">
            <Webform id="newsletter" />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default WebformBlock;
